/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { __decorate } from "tslib";
import { customElement } from 'lit/decorators.js';
import { Ripple } from './internal/ripple.js';
import { styles } from './internal/ripple-styles.js';
/**
 * @summary Ripples, also known as state layers, are visual indicators used to
 * communicate the status of a component or interactive element.
 *
 * @description A state layer is a semi-transparent covering on an element that
 * indicates its state. State layers provide a systematic approach to
 * visualizing states by using opacity. A layer can be applied to an entire
 * element or in a circular shape and only one state layer can be applied at a
 * given time.
 *
 * @final
 * @suppress {visibility}
 */
export let MdRipple = class MdRipple extends Ripple {
};
MdRipple.styles = [styles];
MdRipple = __decorate([
    customElement('md-ripple')
], MdRipple);
//# sourceMappingURL=ripple.js.map